import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  // obtener datos PSS
  obtenerDatosPss: ["payload"],
  obtenerDatosPssLoading: null,
  obtenerDatosPssSuccess: ["obtenerDatosPssData"],
  obtenerDatosPssFailure: ["obtenerDatosPssError"],
  // obtener coberturas contratadas PSS
  obtenerCoberturaContratadaPss: ["payload"],
  obtenerCoberturaContratadaPssLoading: null,
  obtenerCoberturaContratadaPssSuccess: ["obtenerCoberturaContratadaPssData"],
  obtenerCoberturaContratadaPssFailure: ["obtenerCoberturaContratadaPssError"],
  // guardar configuracion coberturas
  guardarCoberturaContratadaPss: ["payload"],
  guardarCoberturaContratadaPssLoading: null,
  guardarCoberturaContratadaPssSuccess: ["guardarCoberturaContratadaPssData"],
  guardarCoberturaContratadaPssFailure: ["guardarCoberturaContratadaPssError"],
  // obtener tipos coberturas
  obtenerTipoCoberturas: ["payload"],
  obtenerTipoCoberturasLoading: null,
  obtenerTipoCoberturasSuccess: ["obtenerTipoCoberturasData"],
  obtenerTipoCoberturasFailure: ["obtenerTipoCoberturasError"],
  // obtener  coberturas
  obtenerCoberturas: ["payload"],
  obtenerCoberturasLoading: null,
  obtenerCoberturasSuccess: ["obtenerCoberturasData"],
  obtenerCoberturasFailure: ["obtenerCoberturasError"],
  // obtener  cobertura documentos
  obtenerCoberturaDocumentos: ["payload"],
  obtenerCoberturaDocumentosLoading: null,
  obtenerCoberturaDocumentosSuccess: ["obtenerCoberturaDocumentosData"],
  obtenerCoberturaDocumentosFailure: ["obtenerCoberturaDocumentosError"],
  // guardar  cobertura documentos
  guardarCoberturaDocumentos: ["payload"],
  guardarCoberturaDocumentosLoading: null,
  guardarCoberturaDocumentosSuccess: ["guardarCoberturaDocumentosData"],
  guardarCoberturaDocumentosFailure: ["guardarCoberturaDocumentosError"],
  // obtener  coberturas configuradas PSS
  obtenerCoberturasConfiguradasPss: ["payload"],
  obtenerCoberturasConfiguradasPssLoading: null,
  obtenerCoberturasConfiguradasPssSuccess: [
    "obtenerCoberturasConfiguradasPssData"
  ],
  obtenerCoberturasConfiguradasPssFailure: [
    "obtenerCoberturasConfiguradasPssError"
  ],

  // obtener documentos coberturas configuradas
  obtenerCoberturasConfiguradasDocumentos: ["payload"],
  obtenerCoberturasConfiguradasDocumentosLoading: null,
  obtenerCoberturasConfiguradasDocumentosSuccess: [
    "obtenerCoberturasConfiguradasDocumentosData"
  ],
  obtenerCoberturasConfiguradasDocumentosFailure: [
    "obtenerCoberturasConfiguradasDocumentosError"
  ]
});

export { Types };

export default Creators;
